// src/pages/Team.jsx
import React, { useEffect, useState } from "react";
import DoctorCard from "../components/DoctorCard";
import DoctorDetailModal from "../components/DoctorDetailModal";
import { supabase } from "../lib/supabase";

const DAYS = ["一", "二", "三", "四", "五", "六"];
const toUiSchedule = (s) => {
  if (!Array.isArray(s) || s.length !== DAYS.length) {
    return DAYS.map((d) => ({
      day: d,
      morning: "",
      afternoon: "",
      evening: "",
    }));
  }
  return s;
};

export default function Team() {
  const [selected, setSelected] = useState(null);
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let abort = false;
    (async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from("doctors")
        .select("*")
        .eq("is_active", true)
        .order("sort_order", { ascending: true, nullsFirst: false })
        .order("created_at", { ascending: true });
      if (abort) return;
      if (error) {
        console.error("[Team] fetch error:", error);
        setDoctors([]);
      } else {
        setDoctors(
          (data || []).map((r) => ({
            id: r.id,
            name: r.name,
            photo: r.photo_url || "/doctors/placeholder.png",
            brief: r.brief || "",
            specialties: Array.isArray(r.specialties) ? r.specialties : [],
            education: Array.isArray(r.education) ? r.education : [],
            experience: Array.isArray(r.experience) ? r.experience : [],
            schedule: toUiSchedule(r.schedule),
          }))
        );
      }
      setLoading(false);
    })();
    return () => {
      abort = true;
    };
  }, []);

  return (
    <section className="team-section">
      <div className="team-inner">
        <h2 className="team-title">醫療團隊</h2>

        {loading ? (
          <div style={{ textAlign: "center", color: "#6b7280" }}>讀取中…</div>
        ) : (
          <div className="doctor-grid">
            {doctors.map((d) => (
              <DoctorCard
                key={d.id}
                doctor={d}
                onClick={() => setSelected(d)}
              />
            ))}
            {!doctors.length && (
              <div
                style={{
                  color: "#6b7280",
                  gridColumn: "1 / -1",
                  textAlign: "center",
                }}
              >
                目前沒有顯示中的醫師
              </div>
            )}
          </div>
        )}

        {selected && (
          <DoctorDetailModal
            doctor={selected}
            onClose={() => setSelected(null)}
          />
        )}
      </div>
    </section>
  );
}
